import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { 
    ApiService, OperationService, CustomerAreaService, CustomerSectorService, PermanentAgentService, CustomerFeedbackService, 
    RetailerService, StoreService 
} from '@app/services';
import { CustomerArea, CustomerSector, Retailer, StoreDirectory } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class DataService {

    initData: boolean = false;
    isFetchingData: Subject<boolean> = new Subject();
    
    constructor(   
        private apiService: ApiService,     
        private operationService: OperationService,
        private customerAreaService: CustomerAreaService,
        private customerSectorService: CustomerSectorService,
        private permanentAgentService: PermanentAgentService,
        private customerFeedbackService: CustomerFeedbackService,
        private retailerService: RetailerService,
        private storeService: StoreService
    ) {}
    
    async init() {
        this.isFetchingData.next(true);        
        await this.operationService.init();
        
        let areas: Array<CustomerArea> = [];
        let sectors: Array<CustomerSector> = [];
        let mapStoresAreas: Map<number, number> = new Map();
        let mapStoresSectors: Map<number, number> = new Map();
        let responseSectors = await this.apiService.get('field-team/current');
        if(responseSectors?.data?.fieldTeamStoreUniveses){
            for(let fieldTeam of responseSectors.data.fieldTeamStoreUniveses){
                if(fieldTeam.areas){
                    for(let area of fieldTeam.areas){
                        
                        let customerArea: CustomerArea = {
                            id: area.areaId,
                            name: area.areaName,
                            code: area.areaName
                        };
                        
                        areas.push(customerArea);
                        
                        if(area.sectors){
                            for(let sector of area.sectors){
                                
                                sectors.push({
                                    id: sector.sectorId,
                                    name: customerArea.name+' - '+sector.sectorName,
                                    code: sector.sectorName,
                                    area: customerArea
                                });

                                if(sector.stores){
                                    for(let store of sector.stores){
                                        mapStoresAreas.set(store.id, area.areaId);
                                        mapStoresSectors.set(store.id, sector.sectorId);
                                    }
                                }
                            }
                        }
                    }
                }
            }            
        }
        
        areas.sort((a, b) => a.name.localeCompare(b.name));
        sectors.sort((a, b) => a.name.localeCompare(b.name));
        
         /*
        await this.customerAreaService.init();
        await this.customerSectorService.init();
        */
        
        CustomerAreaService.Areas = areas;
        CustomerSectorService.Sectors = sectors;
        StoreService.MapStoresAreas = mapStoresAreas;
        StoreService.MapStoresSectors = mapStoresSectors;
       
        let retailers: Array<Retailer> = [];   
        let stores: Array<StoreDirectory> = [];   
        let response = await this.apiService.get('order/store-directory');
        if(response?.data?.stores){
            let mapRetailers: Map<number, Retailer> = new Map();
            for(let store of response.data.stores){
                let areaId = StoreService.MapStoresAreas.get(store.id);
                let sectorId = StoreService.MapStoresSectors.get(store.id);
                if(areaId && sectorId){
                    
                    store.customerArea = areaId;
                    store.customerSector = sectorId;
                    stores.push(store);
                    
                    if(!mapRetailers.has(store.retailer.id)){
                        mapRetailers.set(store.retailer.id, Retailer.FromJson(store.retailer));
                    }
                    
                }
                
            }
            mapRetailers.forEach(e => {
                retailers.push(e);
            });
        }   
          
        retailers.sort((a, b) => a.name.localeCompare(b.name));  
        stores.sort((a, b) => a.name.localeCompare(b.name));  
        
        RetailerService.Retailers = retailers;
        StoreService.Stores = stores;
        
        await this.permanentAgentService.init();
        await this.customerFeedbackService.init();
        this.initData = true;
        this.isFetchingData.next(false);
    }
    
    reset(){
        this.initData = false;
        this.customerAreaService.reset();
        this.customerSectorService.reset();
        this.retailerService.reset();
        this.storeService.reset();
        this.permanentAgentService.reset();
        this.customerFeedbackService.reset();
        this.isFetchingData.next(false);
    }
    
}
